import type { GetTechMeansDTO } from '../service/ai-disclosure.repository.interface';
import type { GetTechMeansRequest, GoalSettingWithRecommend } from '../type/ai-disclosure.type';
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { GetTechMeans } from '@/infrastructure/api-functions/interface/get-tech-means.interface';

@injectable()
export class GetTechMeansDTOImpl implements GetTechMeansDTO {
    constructor(
        @inject(GetTechMeans)
        private readonly _getTechMeansApi: GetTechMeans,
    ) {
    }

    async fetch(value: GetTechMeansRequest): Promise<GoalSettingWithRecommend> {
        const params = {
            task_id: value.taskId,
            current_step: value.currentStep,
            input: value.input,
        };

        const res = await this._getTechMeansApi.getTechMeans(params);

        return {
            inventionSubject: res.invention_subject ?? [],
            applicationField: res.application_field ?? [],
            techMeans: res.tech_means ?? '',
            techEffect: res.tech_effect ?? '',
            other: res.other ?? '',
            recommendInventionSubject: res.recommend_invention_subject ?? [],
            recommendApplicationField: res.recommend_application_field ?? [],
        };
    }
}
